import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { appActions } from './store';

import ChamUpload from './components/features/ChamUpload/ChamUpload';
import ChamProjects from './components/shared/ChamProjects/ChamProjects';
import LandingPage from './components/shared/LandingPage/LandingPage';
import VisualizerPage from './components/features/VisualizerPage/VisualizerPage';
import StartPage from './components/features/StartPage/StartPage';
import { jsonHelper as getJsonBySeriesId } from './Helpers/JsonHelper';

// Create router and export it so components can use router.navigate()
export const router = createBrowserRouter([
    { 
        path: '/', 
        element: <><LandingPage /><ChamProjects /></>, 
        errorElement: <><h1>ERROR</h1></> 
    },
    { 
        path: '/start', 
        element: <><StartPage /><ChamProjects /></>, 
    },
    { 
        path: '/visualizer/spec/:specifier/sel/:selString', 
        element: <><VisualizerPage /><ChamProjects /></>  
    },
]);

function App() {
    const dispatch = useDispatch();

    useEffect(() => {
        const seriesIds = [9699];

        seriesIds.forEach((seriesId) => {
            getJsonBySeriesId(seriesId).then((jsonData) => {
                const data = jsonData.reduce((acc, obj) => {
                    acc[obj.id] = obj;
                    return acc;
                }, {});

                dispatch(appActions.setSeriesData({ data, seriesId }));
            });
        });
    }, [dispatch]);

    return (
        <>
            <RouterProvider router={router} />
            <ChamUpload />
        </>
    );
}

export default App;
